import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
// import '@styles/components/promo/component-promo.scss';
import '@moncler/scss/components/promo-module/promo-module-simplified.scss';
import classNames from 'classnames';
import Lazyimg from '@components/utils/Lazyimg';
import AOS from 'aos';
import { getFirstFocusable } from '@common/scripts/utilities/focusableElementUtils';
const PromoModule = (props) => {
    const { t } = useTranslation();
    const [componentData, setComponentData] = useState(null);
    const [columns, setColumns] = useState([]);
    const cardRefs = useRef([]);
    AOS.init();
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                setComponentData(componentDataRes.data);
                setColumns(componentDataRes.regions[0].components);
            });
        }
    }, []);
    useEffect(() => {
        var _a;
        if (((_a = cardRefs.current) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            cardRefs.current.forEach((card, i) => {
                const link = getFirstFocusable(card);
                if (link) {
                    card.style.cursor = 'pointer';
                    card.addEventListener('click', () => {
                        link.click();
                    });
                }
            });
        }
    }, [columns]);
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null, columns.map((col, i) => (React.createElement("div", { className: classNames('promo-module__promo-column', `text-color--white`), "data-aos": true, "data-aos-anchor-placement": "bottom-bottom", key: i, ref: (el) => (cardRefs.current[i] = el) },
        React.createElement("span", { className: "promo-column__text-holder" },
            React.createElement("p", { className: classNames('promo-column__title'), "data-aos": 'fade-up-min', "data-aos-mirror": "true" }, col.data.title),
            React.createElement("div", { className: "promo-column__cta-holder" }, col.data.link && col.data.linkText && (React.createElement("span", { className: "promo-column__cta", "data-aos": 'fade-up-min', "data-aos-mirror": "true" },
                col.data.linkText && col.data.link && (React.createElement("a", { className: classNames('button', 'button--tertiary-inverted', 'button--arrow-right'), href: col.data.link, "data-analytics-id": props.uuid }, col.data.linkText)),
                col.data.secondLinkText && col.data.secondLink && (React.createElement("a", { className: classNames('button', 'button--tertiary-inverted', 'button--arrow-right'), href: col.data.secondLink, "data-analytics-id": props.uuid }, col.data.secondLinkText)))))),
        React.createElement("span", { className: classNames('parallax-element', 'promo-column__img-holder', `aspect-ratio--${componentData.imageRatio.replace(':', '-')}`) },
            React.createElement("picture", null,
                React.createElement("source", { media: "(max-width: 768px)", srcSet: col.custom.images.mobile.src }),
                React.createElement(Lazyimg, { src: col.custom.images.desktop.src, alt: col.data.imgAlt }))))))));
};
export default PromoModule;
